import Rbac from "@build-security/react-rbac-ui-manager";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    createMuiTheme,
    ThemeProvider,
    withStyles
} from "@material-ui/core/styles";
import auth, { translate, put, startpoll } from "../../js/auth";
import { rbac } from "../../actions/EatWithMeActions";
import { store } from "../..";
import { hasRole } from "../../js/admin";
import SubmenuHeader from "../../components/menus/SubMenuHeader";
import { I18n } from "react-redux-i18n";
import CanAccess from "../../components/CanAccess";

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#4994E4",
            light: "#3C74C3"
        },
        info: {
            main: "#D6EBFF"
        },
        text: {
            primary: "#363C44"
        }
    },
    overrides: {
        MuiTableCell: {
            root: {
                fontSize: "14px",
                padding: "5px 15px",
                borderBottom: 0
            }
        }
    }
});

class EatWithMeRbac extends Component {

    state = {
    };

    componentDidMount = () => {
        auth.zoom = 1;
        if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
    }
    componentDidUpdate = () => {
        auth.zoom = 1;
        if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
    }

    handleChange = (value) => {
        delete value._roles.superadmin;
        put("restaurantService/" + this.props.myStatus.restaurant_id + "/rbac", value);
        store.dispatch(rbac(value));
    };

    render = () => {
        if (!this.props.rbac) {
            return <div></div>;
        }
        return (
            <div id="rbac" style={{ flexGrow: 1, flexShrink: 1, display: "flex", flexFlow: "column", overflowY: "hidden" }}>
                <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.rbac")} />
                <CanAccess resource="administration.rbac">
                    <div style={{ flexGrow: 1, flexShrink: 1, display: "flex", flexFlow: "column", overflowY: "auto" }}>
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around", flexShrink: 0 }}>
                            <ThemeProvider theme={theme}>
                                <Rbac
                                    defaultValue={this.props.rbac}
                                    onChange={this.handleChange}
                                    admin={hasRole(["superadmin"])}
                                    i18nFunction={translate}
                                >
                                </Rbac>
                            </ThemeProvider>
                        </div>
                    </div >
                </CanAccess >
            </div >
        );
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            rbac: state.rbac || props.rootReducer.rbac,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(EatWithMeRbac));
